import React, { createContext, useEffect, useState } from 'react';
import moment from 'moment';
import 'moment/locale/mn';

export const TimeContext = createContext();
const times = [
    '00:00',
    '01:00',
    '02:00',
    '03:00',
    '04:00',
    '05:00',
    '06:00',
    '07:00',
    '08:00',
    '09:00',
    '10:00',
    '11:00',
    '12:00',
    '13:00',
    '14:00',
    '15:00',
    '16:00',
    '17:00',
    '18:00',
    '19:00',
    '20:00',
    '21:00',
    '22:00',
    '23:00',
    '24:00',
];

export const TimeProvider = ({ children }) => {
    const [days, setDays] = useState([]);

    useEffect(() => {
        for (let i = 0; i < 7; i++) {
            moment.locale('mn');
            const day = moment().add(i, 'days');

            setDays((days) => [
                ...days,
                {
                    day: day.format('D'),
                    shortName: day.format('dd'),
                    longName: day.format('dddd'),
                    date: day.format('yy:M:DD')
                },
            ]);
        }
    }, []);

    return (
        <TimeContext.Provider value={{ days, setDays, times }}>
            {children}
        </TimeContext.Provider>
    );
};
